import type { PlayerId } from './player';

export enum Suit {
  HEARTS = 'hearts',
  DIAMONDS = 'diamonds',
  CLUBS = 'clubs',
  SPADES = 'spades',
}

export enum Rank {
  TWO = 2,
  THREE = 3,
  FOUR = 4,
  FIVE = 5,
  SIX = 6,
  SEVEN = 7,
  EIGHT = 8,
  NINE = 9,
  TEN = 10,
  JACK = 11,
  QUEEN = 12,
  KING = 13,
  ACE = 14,
}

export interface Card {
  suit: Suit;
  rank: Rank;
  id: string; // Unique identifier: "hearts-14" (Ace of Hearts)
}

export interface PlayedCard {
  card: Card;
  playerId: PlayerId;
  playOrder: number; // 0-3 within trick
}

export type Deck = Card[];

export function createCardId(suit: Suit, rank: Rank): string {
  return `${suit}-${rank}`;
}

export function parseCardId(id: string): { suit: Suit; rank: Rank } | null {
  const parts = id.split('-');
  if (parts.length !== 2) return null;

  const suit = parts[0] as Suit;
  const rank = parseInt(parts[1], 10) as Rank;

  if (!Object.values(Suit).includes(suit)) return null;
  if (!Object.values(Rank).includes(rank)) return null;

  return { suit, rank };
}

export const SUIT_SYMBOLS: Record<Suit, string> = {
  [Suit.HEARTS]: '\u2665',
  [Suit.DIAMONDS]: '\u2666',
  [Suit.CLUBS]: '\u2663',
  [Suit.SPADES]: '\u2660',
};

export const RANK_LABELS: Record<Rank, string> = {
  [Rank.TWO]: '2',
  [Rank.THREE]: '3',
  [Rank.FOUR]: '4',
  [Rank.FIVE]: '5',
  [Rank.SIX]: '6',
  [Rank.SEVEN]: '7',
  [Rank.EIGHT]: '8',
  [Rank.NINE]: '9',
  [Rank.TEN]: '10',
  [Rank.JACK]: 'J',
  [Rank.QUEEN]: 'Q',
  [Rank.KING]: 'K',
  [Rank.ACE]: 'A',
};
